export const SET_LANGUAGE = '@@localization/SET_LANGUAGE';
